import React from 'react';

import { Tooltip } from 'reactstrap';

import Block from './block';
import Title from './my-title';

import ReassuranceBackgroundImage from '../assets/reassurance-background.jpg';

import FreeQuoteIcon from '../assets/icon/free-quote.svg';
import HightReliableIcon from '../assets/icon/hight-reliable.svg';
import MadeInFranceIcon from '../assets/icon/made-in-france.svg';
import PersonalisedConsultingIcon from '../assets/icon/personalised-consulting.svg';

import InformationIcon from '../assets/icon/information.svg';

const data = [
  {
    iconUrl: FreeQuoteIcon,
    title: (
      <span>Des devis<br />gratuits</span>
    ),
    subtitle: (
      <span>pour toute prestation<br /> de menuiserie</span>
    )
  },
  {
    iconUrl: PersonalisedConsultingIcon,
    title: (
      <span>Une étude et des<br />conseils personnalisés</span>
    ),
    subtitle: (
      <span>de votre projet<br /> de menuiserie</span>
    )
  },
  {
    iconUrl: HightReliableIcon,
    title: (
      <span>Une garantie<br />décennale</span>
    ),
    subtitle: (
      <span>sur tous nos travaux<br /> en bois</span>
    )
  },
  {
    iconUrl: MadeInFranceIcon,
    title: (
      <span>Une fabrication<br />française</span>
    ),
    subtitle: (
      <span>sur-mesure<br /> dans nos ateliers</span>
    ),
    more: (
      <p className="mb-0">
        Le respect des <strong>normes françaises</strong> du travail du bois<br /><br />
        Une mobilité sur toute <strong>la région parisienne</strong>
      </p>
    )
  },
];

class TooltipItem extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  render() {
    return (
      <div>
        <img src={InformationIcon} alt="Information" className="mt-3" id={'Tooltip-' + this.props.id} />
        <Tooltip placement="bottom" isOpen={this.state.isOpen} target={'Tooltip-' + this.props.id} toggle={this.toggle}>
          {this.props.children}
        </Tooltip>
      </div>
    )
  }
}

const BlockReassurance = ({ hasDecoration = true }) => (
  <Block backgroundUrl={ReassuranceBackgroundImage} hasDecoration={hasDecoration}>
    <Title>Nos engagements</Title>

    <div className="row">
      {data.map((item, index) => (
        <div className="col-md-3 mb-4 mb-md-0 text-align-center" key={index}>
          <img className="mb-2" src={item.iconUrl} role="presentation" />
          <p className="uppercase color-red fs-15 text-align-center bold mb-0">{item.title}</p>
          <p className="fs-16 text-align-center mb-0">{item.subtitle}</p>
          {item.more ? (
            <TooltipItem id={index}>
              {item.more}
            </TooltipItem>
          ) : null}
        </div>
      ))}
    </div>
  </Block>
)

export default BlockReassurance;



// WEBPACK FOOTER //
// ./src/components/block-reassurance.js